import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row no-gutters" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "col-md-9" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-subtitle" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-danger font-weight-bold" }

import { format_date, format_unit } from '@/helpers/filters'
import * as moment from 'moment'
import { Moment } from 'moment'
import { ProductInfo } from '@/types/api'
import { computed } from 'vue'
import SilpoCategoryPath from "@/components/shopping/silpo/SilpoCategoryPath.vue";
import SilpoProductInfoActions from "@/components/shopping/silpo/SilpoProductInfoActions.vue";

interface Props {
  productInfo: ProductInfo
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoProductInfo',
  props: {
    productInfo: null
  },
  setup(__props: any) {

const props = __props as {
  productInfo: ProductInfo
};



const priceStartFrom = computed((): Moment => moment(props.productInfo.price_start_from))

const priceStopAfter = computed((): Moment => moment(props.productInfo.price_stop_after))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: props.productInfo.image_url || '/images/square-placeholder.jpeg',
          alt: props.productInfo.name,
          class: "card-img-bottom",
          style: _normalizeStyle({filter: `grayscale(${__props.productInfo.is_available ? 0 : 1})`})
        }, null, 12, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h5", _hoisted_7, _toDisplayString(props.productInfo.name), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(format_unit)(props.productInfo.unit)), 1),
          (props.productInfo.category_id)
            ? (_openBlock(), _createBlock(SilpoCategoryPath, {
                key: 0,
                class: "card-subtitle",
                "category-id": props.productInfo.category_id,
                "vendor-code": props.productInfo.id
              }, null, 8, ["category-id", "vendor-code"]))
            : _createCommentVNode("", true),
          (!props.productInfo.old_price)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(props.productInfo.price) + " грн.", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("s", null, _toDisplayString(props.productInfo.old_price) + " грн.", 1)
              ])),
          (!!props.productInfo.old_price)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(props.productInfo.price) + " грн.", 1),
                _createElementVNode("div", null, _toDisplayString(_unref(format_date)(_unref(priceStartFrom), 'short')) + " - " + _toDisplayString(_unref(format_date)(_unref(priceStopAfter), 'short')), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(SilpoProductInfoActions, {
            "price-chart-height": "200px",
            "vendor-code": props.productInfo.id
          }, null, 8, ["vendor-code"])
        ])
      ])
    ])
  ]))
}
}

})